import React, { useState, useEffect } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useLoginCheck } from "../../../../hooks/useLoginCheck";

import "../../../../styles/scss/recital2025SpecialFee.scss";

function SpecialFeePage() {
  useLoginCheck();

  const [salaryList, setSalaryList] = useState([]);
  const [originalSalaryList, setOriginalSalaryList] = useState([]);
  const [message, setMessage] = useState("");

  const fetchSpecialFeesData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${apiUrl}/api/get_recital2026_special_fees/`
      );
      if (!response.ok) {
        throw new Error("ネットワークレスポンスが異常です。");
      }
      const data = await response.json();
      setSalaryList(data);
      setOriginalSalaryList(data);
      console.log(data);
    } catch (error) {
      console.error("データの取得中にエラーが発生しました:", error);
    }
  };

  const handleInputChange = (e, instructor_id, field) => {
    let { value } = e.target;

    // fee1フィールドのみ小数点を許可、他は整数のみ
    if (field === "fee1") {
      if (value !== "" && !/^\d*\.?\d*$/.test(value)) {
        return;
      }
    } else {
      if (value !== "" && !/^\d+$/.test(value)) {
        return;
      }
    }

    value = value === "" ? 0 : Number(value);

    setSalaryList((prevSalaryList) =>
      prevSalaryList.map((item) =>
        item.instructor_id === instructor_id
          ? { ...item, [field]: value }
          : item
      )
    );
  };

  const handleTextareaChange = (e, instructor_id, field) => {
    const { value } = e.target;
    setSalaryList((prevSalaryList) =>
      prevSalaryList.map((item) =>
        item.instructor_id === instructor_id
          ? { ...item, [field]: value }
          : item
      )
    );
  };

  const updateDatabase = async (
    instructor_id,
    field,
    value,
    instructor_name
  ) => {
    setMessage("");

    const originalValue = originalSalaryList.find(
      (item) => item.instructor_id === instructor_id
    )[field];

    if (value == originalValue) {
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${apiUrl}/api/update_recital2026_special_fee/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ instructor_id, field, value }),
        }
      );
      if (!response.ok) {
        throw new Error("データベースの更新に失敗しました。");
      }

      setOriginalSalaryList((prevOriginalSalaryList) =>
        prevOriginalSalaryList.map((item) =>
          item.instructor_id === instructor_id
            ? { ...item, [field]: value }
            : item
        )
      );

      setMessage(instructor_name);
      console.log("データベースが正常に更新されました。");
    } catch (error) {
      alert("データベースの更新中にエラーが発生しました");
      console.error("データベースの更新中にエラーが発生しました:", error);
    }
  };

  useEffect(() => {
    fetchSpecialFeesData();
  }, []);

  // 給与項目のラベルを取得（最初のインストラクターから）
  const feeLabels = salaryList.length > 0 ? salaryList[0].fee_labels || {} : {};

  return (
    <>
      <p
        className={`${message ? "save-anime on" : "save-anime"}`}
        style={{ display: message ? "block" : "none" }}
      >
        保存{message && `<${message}>`}
      </p>

      <h2>26発表会 給与</h2>
      <div className="graph">
        {/* インストラクター名 */}
        <ul>
          <li>イントラ名</li>
          {salaryList &&
            salaryList.map((intr) => (
              <li key={intr.instructor_id}>{intr.instructor_name}</li>
            ))}
        </ul>

        {/* fee1~fee6をループで表示 */}
        {[1, 2, 3, 4, 5, 6].map((num) => (
          <ul key={num}>
            <li>{feeLabels[num] || `給与${num}`}</li>
            {salaryList &&
              salaryList.map((intr) => (
                <li key={intr.instructor_id}>
                  <input
                    type="tel"
                    className="price"
                    value={intr[`fee${num}`]}
                    onChange={(e) =>
                      handleInputChange(e, intr.instructor_id, `fee${num}`)
                    }
                    onBlur={(e) =>
                      updateDatabase(
                        intr.instructor_id,
                        `fee${num}`,
                        e.target.value,
                        intr.instructor_name
                      )
                    }
                  />{" "}
                  *{" "}
                  <input
                    type="tel"
                    className="count"
                    value={intr[`count${num}`]}
                    onChange={(e) =>
                      handleInputChange(e, intr.instructor_id, `count${num}`)
                    }
                    onBlur={(e) =>
                      updateDatabase(
                        intr.instructor_id,
                        `count${num}`,
                        e.target.value,
                        intr.instructor_name
                      )
                    }
                  />
                  <span className="total">
                    {intr[`fee${num}`] * intr[`count${num}`]}円
                  </span>
                  <textarea
                    value={intr[`memo${num}`] || ""}
                    onChange={(e) =>
                      handleTextareaChange(e, intr.instructor_id, `memo${num}`)
                    }
                    onBlur={(e) =>
                      updateDatabase(
                        intr.instructor_id,
                        `memo${num}`,
                        e.target.value,
                        intr.instructor_name
                      )
                    }
                  />
                </li>
              ))}
          </ul>
        ))}

        {/* 合計 */}
        <ul className="calc_total_list">
          <li>合計</li>
          {salaryList &&
            salaryList.map((intr) => {
              const total = [1, 2, 3, 4, 5, 6].reduce(
                (sum, num) =>
                  sum + (intr[`fee${num}`] || 0) * (intr[`count${num}`] || 0),
                0
              );
              return <li key={intr.instructor_id}>{total}円</li>;
            })}
        </ul>
      </div>
    </>
  );
}

export default SpecialFeePage;
